import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

const STATUS_LABEL = {
  queued: 'Queued',
  running: 'Generating',
  complete: 'Ready',
  failed: 'Failed'
}

const STATUS_COLOR = {
  queued: '#7B8794',
  running: '#3F8CFF',
  complete: '#34C77B',
  failed: '#E04141'
}

const ProfileCard = ({ profile, onSelect, showGeneratedBy }) => {
  const clickable =
    profile.status === 'complete' && Boolean(onSelect)
  const statusLabel =
    STATUS_LABEL[profile.status] || profile.status
  const statusColor = STATUS_COLOR[profile.status] || '#7B8794'

  const dateLabel = profile.completedAt
    ? moment(profile.completedAt).format('MMM D, YYYY')
    : moment(profile.createdAt).format('MMM D, YYYY')

  const handleClick = () => {
    if (clickable) onSelect(profile.id)
  }

  return (
    <div
      onClick={handleClick}
      className="p-20 border rounded h-100 bg-white d-flex flex-column"
      style={{
        cursor: clickable ? 'pointer' : 'default',
        opacity: clickable ? 1 : 0.7,
        transition: 'box-shadow 0.15s ease',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        minHeight: 120
      }}
    >
      <div className="d-flex justify-content-between align-items-start mb-10">
        <p
          className="font-weight-bold mb-0"
          style={{ fontSize: 16 }}
        >
          {dateLabel}
        </p>
        <span
          className="font-weight-bold"
          style={{ fontSize: 12, color: statusColor }}
        >
          {statusLabel}
        </span>
      </div>

      <p
        className="text-gray-dark mb-0"
        style={{ fontSize: 13 }}
      >
        {profile.meetingCount}{' '}
        {profile.meetingCount === 1 ? 'meeting' : 'meetings'}
        {showGeneratedBy && profile.generatedByUserId
          ? ' · generated by coach'
          : ''}
      </p>

      {clickable && (
        <p
          className="text-primary mb-0 mt-auto pt-10"
          style={{ fontSize: 13 }}
        >
          View profile ›
        </p>
      )}
    </div>
  )
}

ProfileCard.propTypes = {
  profile: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  showGeneratedBy: PropTypes.bool
}

export default ProfileCard
